<div class="cardapio-footer">
  <button pButton
          [label]="texts.ver_menu"
          icon="pi pi-external-link"
          class="p-button-outlined footer-btn"
          (click)="verMenu.emit()">
  </button>
  <button pButton
          [label]="texts.qr_links"
          icon="pi pi-qrcode"
          class="p-button-outlined footer-btn"
          (click)="qrLinks.emit()">
  </button>
</div>
